import ServicePageTemplate from '@/pages/services/components/ServicePageTemplate';
import { internalWorkflows } from '@/mocks/servicePages';
import IntApproval from './components/IntApproval';

export default function InternalWorkflowsPage() {
  return <ServicePageTemplate data={internalWorkflows} system={<IntApproval />} />;
}